import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';
import Child from './modules/Child.store';
import Couple from './modules/Couple.store';
import Pet from './modules/Pet.store';
import Miscarriage from './modules/Miscarriage.store';
import Moves from './modules/Moves.store';
import AstralCard from './modules/AstralCard.store';
import Appoinments from "./modules/Appoinments.store";
import $day from "dayjs"
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user : {
      namespaced: true,
      state: {
        info: {}
      },

      mutations: {
        setInfo: (state, info) => {
          info.user_data = info.user_data ? info.user_data:{}
          state.info = info
        },
        updateInfo: (state, info) => state.info.user_data = info.user_data,
        setMail: (state, info) => state.info.user.email = info.user.email,
       /*setPassword: (state, info) => state.info.password = info.user.password*/
      },
      actions: {
        async fetchInfo ({commit}) {
          const response = await axios.get('user/me')
          commit ('setInfo', response.data)
        },
        async changeMail ({commit}, data) {
          const response = await axios.put('user/email', {email: data})
          commit ('setMail', response.data)
          return response.data
        },
        async updateInfo ({commit}, data) {
          data.info.user_data.birth_date = $day(data.info.user_data.birth_date).format('YYYY-MM-DD HH:mm:ss')
          data.info.user_data.display_name = data.info.user_data.names + ' ' + data.info.user_data.surnames
          let response = {}
          if (data.info.user_data.id) {
            response = await axios.put('user/data/'+data.info.user_data.id, data.info.user_data)
          } else {
            response = await axios.post('user/data', data.info.user_data)
          }
          commit ('updateInfo', response.data)
        },

       /* async updatePassword ({commit}, data) {
          const response = await axios.put('user/credential', data.password)
          commit('setPassword', response.data)
        }*/
      }
    },
    child: Child,
    couple: Couple,
    pet: Pet,
    miscarriage: Miscarriage,
    moves: Moves,
    astralCard: AstralCard,
    appoinments: Appoinments
  },

  state: {
    mainLoader: false,
  },
  mutations: {
    setLoader: (state, flag) => state.mainLoader = flag,
  },
  actions: {
    loaderChange({commit}, flag) {
      commit ('setLoader', flag)
    }
  }
})
